import { isPaymentAttachmentField } from '../../../helpers/paymentAttachmentCodes'

export function formatNoEffectiveVisitDate(createdDate) {
  if (!createdDate) return '-'

return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(new Date(createdDate))
}

export function buildNoEffectiveVisitSummaryFields(activity) {
  if (!activity) return []

  return [
    {
      label: 'Fecha de creación',
      value: formatNoEffectiveVisitDate(activity.created_date)
    },
    {
      label: 'Número de la visita',
      value: activity.no_effective_visit_db_ref || activity.db_ref || '-'
    },
    {
      label: 'Vendedor',
      value: activity.salesman_name || '-'
    },
    {
      label: 'Tipo de reporte',
      value: activity.report_type || '-'
    },
    {
      label: 'Motivo / descripción',
      value: activity.motive || activity.client_description || 'N/A'
    }
  ]
}

export function buildNoEffectiveVisitFields(customFields = []) {
  if (!customFields?.length) return []

  return customFields
    .filter((field) => field && !isPaymentAttachmentField(field))
    .map(({ label, value }) => ({
      label: label || '-',
      value: value || '-'
    }))
}
